// locales/sl.ts
export const slovenianLocale = {
    accept: 'Da',
    reject: 'Ne',
    today: 'Danes',
    clear: 'Počisti',
    dayNames: ['Nedelja', 'Ponedeljek', 'Torek', 'Sreda', 'Četrtek', 'Petek', 'Sobota'],
    dayNamesShort: ['Ned', 'Pon', 'Tor', 'Sre', 'Čet', 'Pet', 'Sob'],
    dayNamesMin: ['N', 'P', 'T', 'S', 'Č', 'P', 'S'],
    monthNames: ['Januar', 'Februar', 'Marec', 'April', 'Maj', 'Junij', 'Julij', 'Avgust', 'September', 'Oktober', 'November', 'December'],
    monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Avg', 'Sep', 'Okt', 'Nov', 'Dec'],
    weekHeader: 'Teden',
    firstDayOfWeek: 1,
    dateFormat: 'dd.mm.yy',
    weak: 'Šibko',
    medium: 'Srednje',
    strong: 'Močno',
    passwordPrompt: 'Vnesite geslo',
    emptyFilterMessage: 'Ni rezultatov',
    emptyMessage: 'Ni podatkov',
    fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    aria: {
        trueLabel: 'Da',
        falseLabel: 'Ne',
        nullLabel: 'Ni izbrano',
        star: '1 zvezdica',
        stars: '{star} zvezdice',
        selectAll: 'Izberi vse',
        unselectAll: 'Počisti vse',
        close: 'Zapri',
        previous: 'Prejšnje',
        next: 'Naslednje',
        navigation: 'Navigacija',
        scrollTop: 'Na vrh',
        moveTop: 'Premakni na vrh',
        moveUp: 'Premakni gor',
        moveDown: 'Premakni dol',
        moveBottom: 'Premakni na dno',
        moveToTarget: 'Premakni v ciljno',
        moveToSource: 'Premakni v izvorno',
        moveAllToTarget: 'Premakni vse v ciljno',
        moveAllToSource: 'Premakni vse v izvorno',
        pageLabel: 'Stran {page}',
        firstPageLabel: 'Prva stran',
        lastPageLabel: 'Zadnja stran',
        nextPageLabel: 'Naslednja stran',
        previousPageLabel: 'Prejšnja stran',
        rowsPerPageLabel: 'Vrstic na stran',
        jumpToPageDropdownLabel: 'Pojdi na stran',
        jumpToPageInputLabel: 'Vnesi številko strani',
        selectRow: 'Izberi vrstico',
        unselectRow: 'Počisti vrstico',
        expandRow: 'Razširi vrstico',
        collapseRow: 'Strni vrstico',
        showFilterMenu: 'Pokaži meni filtrov',
        hideFilterMenu: 'Skrij meni filtrov',
        filterOperator: 'Operator filtra',
        filterConstraint: 'Pogoj filtra',
        editRow: 'Uredi vrstico',
        saveEdit: 'Shrani urejanje',
        cancelEdit: 'Prekliči urejanje',
        listView: 'Seznamski pogled',
        gridView: 'Mrežni pogled',
        slide: 'Diapozitiv',
        slideNumber: '{slideNumber}',
        zoomImage: 'Povečaj sliko',
        zoomIn: 'Povečaj',
        zoomOut: 'Pomanjšaj',
        rotateRight: 'Zavrti desno',
        rotateLeft: 'Zavrti levo',
        choose: 'Izberi',
        upload: 'Naloži',
        cancel: 'Prekliči',
        remove: 'Odstrani'
    }
}
